<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <g>
      <path
        d="M4.82031 4.8125C3.14062 6.375 2.00781 8.25 1.5 9.5C2.00781 10.75 3.14062 12.625 4.82031 14.1875C6.5 15.75 8.72656 17 11.5 17C14.2344 17 16.4609 15.75 18.1406 14.1875C19.8203 12.625 20.9531 10.75 21.5 9.5C20.9531 8.25 19.8203 6.375 18.1406 4.8125C16.4609 3.25 14.2344 2 11.5 2C8.72656 2 6.5 3.25 4.82031 4.8125ZM11.5 0.75C14.625 0.75 17.1641 2.19531 19 3.91406C20.8359 5.59375 22.0469 7.625 22.6328 9.03125C22.75 9.34375 22.75 9.69531 22.6328 10.0078C22.0469 11.375 20.8359 13.4062 19 15.125C17.1641 16.8438 14.625 18.25 11.5 18.25C8.33594 18.25 5.79688 16.8438 3.96094 15.125C2.125 13.4062 0.914062 11.375 0.328125 10.0078C0.210938 9.69531 0.210938 9.34375 0.328125 9.03125C0.914062 7.625 2.125 5.59375 3.96094 3.91406C5.79688 2.19531 8.33594 0.75 11.5 0.75ZM7.75 9.5C7.75 10.8672 8.45312 12.0781 9.625 12.7812C10.7578 13.4453 12.2031 13.4453 13.375 12.7812C14.5078 12.0781 15.25 10.8672 15.25 9.5C15.25 8.17188 14.5078 6.96094 13.375 6.25781C12.2031 5.59375 10.7578 5.59375 9.625 6.25781C8.45312 6.96094 7.75 8.17188 7.75 9.5ZM16.5 9.5C16.5 11.2969 15.5234 12.9375 14 13.8359C12.4375 14.7344 10.5234 14.7344 9 13.8359C7.4375 12.9375 6.5 11.2969 6.5 9.5C6.5 7.74219 7.4375 6.10156 9 5.20312C10.5234 4.30469 12.4375 4.30469 14 5.20312C15.5234 6.10156 16.5 7.74219 16.5 9.5Z"
        :fill="iconColor"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
